import React from 'react';
import {
  shape, number, oneOfType, arrayOf,
} from 'prop-types';
import './FormMenu.scss';
import BreadcrumbNumberCircle from 'components/common/BreadcrumbNumberCircle';

const FormMenu = ({
  steps, selectedIndex,
}) => (
  <div className="form-menu-desktop">
    {Object
      .entries(steps).map((step, i) => (
        <div key={step[0]}>
          <BreadcrumbNumberCircle
            number={selectedIndex <= i ? i + 1 : '✓'}
            id={step[0]}
            title={step[1].stepTitle}
            active={selectedIndex === i}
          />
        </div>
      ))}
  </div>
);

FormMenu.defaultProps = {
  steps: {},
};

FormMenu.propTypes = {
  steps: oneOfType([shape({}), arrayOf(shape({}))]),
  selectedIndex: number.isRequired,
};

export default FormMenu;
